import { Media } from '@pixacare/domain';

// Optimistic placeholders carry a temporary negative id until the real, server-assigned media
// replaces them.
export const isOptimisticMedia = (media: Media): boolean => media.id < 0;
